import { useQuery } from "@tanstack/react-query";

import { getFarmsByCarbonProgram } from "services";

import { GET_FARMS_BY_CARBON_PROGRAM } from "consts";

interface FarmQueryParams {
  limit: number;
  page: number;
  name?: string;
  carbonProgramId?: string;
}

export const useGetFarmsByCarbonProgram = (params: FarmQueryParams = { limit: 20, page: 1 }) =>
  useQuery({
    queryKey: [GET_FARMS_BY_CARBON_PROGRAM, params],
    queryFn: async () => getFarmsByCarbonProgram({ params }),
  });
